import { withIframeClient } from '@yoti-web-share/iframe-client'
import { withShareFlow } from '@yoti-web-share/share-flow'

export default WrappedComponent => withShareFlow(withIframeClient(WrappedComponent))
